import { toQueryString } from ".";
import { BulkResponse, PaginatedStaffReferral, StaffReferral, StaffReferralRequest, StaffReferralWithUsers } from "../model/referral/referral";
import { apiSlice } from "../stores/base/api-slice";
import { StaffReferralSingleRequest } from "./contract";


interface StaffDetailsWithUsersRequest{
    page: number;
    pageSize: number;
    search? : string;
    fromDate? : string;
    toDate? : string;
    StaffReferralId: string;
}

const referralEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
          getStaffReferrals: builder.query<PaginatedStaffReferral<StaffReferral>, StaffReferralRequest>({
            query: (params) => ({
                url: `/user/staff-referrals/page${toQueryString(params)}`,
                method: 'GET',
            }),
            providesTags: ["StaffReferral"]
            
        }),

        addSingleStaffReferral: builder.mutation<void, StaffReferralSingleRequest>({
            query: (body) => ({
                url: `/user/staff-referrals/add-single`,
                method: 'POST',
                body
            }),
            invalidatesTags:["StaffReferral"]

        }),

        addBulkStaffReferral: builder.mutation<BulkResponse, File>({
            query: (file) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: `/user/staff-referrals/bulk-upload`,
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: ["StaffReferral"]
        })
        ,

        getExampleFile: builder.query<void, void>({
            query: () => ({
                url: `/user/staff-referrals/bulk-upload/template`,
                method: 'GET',
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'BulkStaffUploadTemplate.xlsx';
                    a.click();
                    window.URL.revokeObjectURL(url);
                },
                cache: 'no-cache',
            })
        }),

        getStaffDetails: builder.query<StaffReferralWithUsers, StaffDetailsWithUsersRequest>({
            query: (param) => ({
                url: `/user/staff-referrals/by-id${toQueryString(param)}`,
                method: 'GET'
            })
        })
    })
})


export const {
    useGetStaffReferralsQuery,
    useAddSingleStaffReferralMutation,
    useAddBulkStaffReferralMutation,
    useLazyGetExampleFileQuery,
    useGetStaffDetailsQuery
} = referralEndpoints;